// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Orders_Types_ServingAreaId from "../Restaumatic.Orders.Types.ServingAreaId/index.js";
import * as Restaumatic_RouteAsURL from "../Restaumatic.RouteAsURL/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq1 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Orders_Types_ServingAreaId.eqServingAreaId);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var numberIsSymbol = {
    reflectSymbol: function () {
        return "number";
    }
};
var TableIsSymbol = {
    reflectSymbol: function () {
        return "Table";
    }
};
var areaIdIsSymbol = {
    reflectSymbol: function () {
        return "areaId";
    }
};
var areaNameIsSymbol = {
    reflectSymbol: function () {
        return "areaName";
    }
};
var pointNameIsSymbol = {
    reflectSymbol: function () {
        return "pointName";
    }
};
var ServingLocationIsSymbol = {
    reflectSymbol: function () {
        return "ServingLocation";
    }
};
var decodeSingleConstructorAr = /* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr();
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var decodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeRecordCons1 = /* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil);
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var Table = /* #__PURE__ */ (function () {
    function Table(value0) {
        this.value0 = value0;
    };
    Table.create = function (value0) {
        return new Table(value0);
    };
    return Table;
})();
var ServingLocation = /* #__PURE__ */ (function () {
    function ServingLocation(value0) {
        this.value0 = value0;
    };
    ServingLocation.create = function (value0) {
        return new ServingLocation(value0);
    };
    return ServingLocation;
})();
var toFillFormTypeDineInLocat = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var eqDineInLocation = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Table && y instanceof Table) {
                return x.value0.number === y.value0.number;
            };
            if (x instanceof ServingLocation && y instanceof ServingLocation) {
                return eq1(x.value0.areaId)(y.value0.areaId) && x.value0.areaName === y.value0.areaName && x.value0.pointName === y.value0.pointName;
            };
            return false;
        };
    }
};
var genericDineInLocation = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Table(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new ServingLocation(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.DineInLocation (line 20, column 1 - line 20, column 83): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Table) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof ServingLocation) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.DineInLocation (line 20, column 1 - line 20, column 83): " + [ x.constructor.name ]);
    }
};
var showDineInLocation = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDineInLocation)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(numberIsSymbol)(Data_Show.showInt))))(TableIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(areaIdIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(areaNameIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(pointNameIsSymbol)(Data_Show.showString))(Data_Show.showString))(Restaumatic_Orders_Types_ServingAreaId.showServingAreaId))))(ServingLocationIsSymbol)))
};
var unscrambleDecodeDineInLocation = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericDineInLocation)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(TableIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ Unscramble.decodeRecordCons(numberIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ServingLocationIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ Unscramble.decodeRecordCons(areaIdIsSymbol)(Restaumatic_Orders_Types_ServingAreaId.udecodeServingAreaId)(/* #__PURE__ */ Unscramble.decodeRecordCons(areaNameIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(pointNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var encodeDineInLocation = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericDineInLocation)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(TableIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons1(numberIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ServingLocationIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(pointNameIsSymbol)(encodeWithOptionsOther))(areaNameIsSymbol)(encodeWithOptionsOther))(areaIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Types_ServingAreaId.encodeServingAreaId)))))))
};
var decodeDineInLocation = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericDineInLocation)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(TableIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons1(numberIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ServingLocationIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(pointNameIsSymbol)(decodeWithOptionsOther)())(areaNameIsSymbol)(decodeWithOptionsOther)())(areaIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Types_ServingAreaId.decodeServingAreaId))())))(Foreign_Generic_Class.genericCountArgsArgument)))
};
var asParamDineInLocation = {
    fromParam: /* #__PURE__ */ Restaumatic_RouteAsURL.fromParamJSON(decodeDineInLocation),
    toParam: /* #__PURE__ */ Restaumatic_RouteAsURL.toParamJSON(encodeDineInLocation)
};
export {
    Table,
    ServingLocation,
    asParamDineInLocation,
    genericDineInLocation,
    eqDineInLocation,
    showDineInLocation,
    encodeDineInLocation,
    decodeDineInLocation,
    unscrambleDecodeDineInLocation,
    toFillFormTypeDineInLocat
};
